import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Switch } from 'antd';
import PropostaComercialSection from './PropostaComercialSection';
import ParcelCalculator from './ParcelCalculator';
import PadraoAtualSection from './PadraoAtualSection';
import ModulosInversoresSection from './ModulosInversoresSection';
import FileUploadField from '../../shared/FileUploadField';
import { CategoriaArquivo } from '@engenharia/shared';
import { useFormStore } from '../../../store/formStore';
import type { CategoriaArquivo as CatType } from '@engenharia/shared';

interface Props {
  onUpload: (categoria: CatType, file: File) => void;
  onDelete: (id: number) => void;
  uploadStates: Record<string, { uploading: boolean; progress: number }>;
}

export default function Step2Pagamento({ onUpload, onDelete, uploadStates }: Props) {
  const { watch, control } = useFormContext();
  const tipoSolicitacao = watch('tipo_solicitacao');
  const isVenda = tipoSolicitacao === 'VendaConcluida';
  const ampliacao = watch('ampliacao_usina');
  const arquivos = useFormStore((s) => s.arquivos);

  return (
    <div>
      {isVenda && (
        <>
          <PropostaComercialSection />
          <ParcelCalculator />
        </>
      )}

      <PadraoAtualSection onUpload={onUpload} onDelete={onDelete} uploadStates={uploadStates} />

      <ModulosInversoresSection />

      <div className="border rounded-lg p-4 mb-4">
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Contrato com Seguro</label>
          <Controller
            name="contrato_com_seguro"
            control={control}
            render={({ field }) => (
              <Switch checked={field.value} onChange={field.onChange} />
            )}
          />
        </div>
      </div>

      {ampliacao && (
        <FileUploadField
          label="Foto Material Usina Existente"
          categoria={CategoriaArquivo.FotoMaterialUsinaExistente}
          arquivos={arquivos}
          uploading={uploadStates[CategoriaArquivo.FotoMaterialUsinaExistente]?.uploading || false}
          progress={uploadStates[CategoriaArquivo.FotoMaterialUsinaExistente]?.progress || 0}
          multiple
          onUpload={onUpload}
          onDelete={onDelete}
        />
      )}
    </div>
  );
}
